import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const blockUserService = {
  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.blockUser.getAll, { params });
    return response.data;
  },

  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.blockUser.getAllSearch, { params, signal });
    return response.data;
  },

  async block(data) {
    const response = await apiClient.post(endPoints.blockUser.block, data);
    return response.data;
  },

  async toggle(id) {
    const response = await apiClient.patch(`${endPoints.blockUser.toggle}/${id}`);
    return response.data;
  },
};
